import React, { Component } from "react";
import PropTypes from "prop-types";
import Loading from "./Loading";
import InputRow from "./InputRow";

export default class EducationHistoryUndergraduate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: "",
      highSchoolCertificateData: [],
      highSchoolNameData: [],
      undergradDegree: [
        {
          highSchoolCertificate: "",
          startDate: "",
          endDate: "",
          highSchoolName: "",
          institutionName: "",
          sectionSpeciality: "",
        },
      ],
    };
  }

  componentDidMount() {
    Promise.all([
      fetch(
        `${process.env.REACT_APP_API_URL}/api/EducationHistory/GetSchoolCurriculum`
      ).then((res) => res.json()),
      fetch(
        `${process.env.REACT_APP_API_URL}/api/EducationHistory/GetSchoolName`
      ).then((res) => res.json()),
    ])
      .then(([certificates, schools]) => {
        const prefilledUndergradDegree = this.props.educationHistory?.length
          ? this.props.educationHistory.map((item) => ({
              highSchoolCertificate: item.CurriculumId?.toString() || "",
              startDate: item.StartDate ? item.StartDate.slice(0, 10) : "",
              endDate: item.EndDate ? item.EndDate.slice(0, 10) : "",
              highSchoolName: item.InstitutionId || "",
              institutionName: item.InstitutionName || "",
              sectionSpeciality: item.SectionSpeciality || "",
            }))
          : [
              {
                highSchoolCertificate: "",
                startDate: "",
                endDate: "",
                highSchoolName: "",
                institutionName: "",
                sectionSpeciality: "",
              },
            ];

        this.setState(
          {
            highSchoolCertificateData: certificates,
            highSchoolNameData: schools,
            undergradDegree: prefilledUndergradDegree,
            loading: false,
          },
          () => {
            /* EDIT #1 – notify parent even if user does nothing */
            this.props.collectState("EH", {
              underGradDegree: prefilledUndergradDegree,
            });
          }
        );
      })
      .catch(console.error);
  }

  handleChange(index, field, value) {
    const updated = [...this.state.undergradDegree];
    updated[index][field] = value;

    if (field === "highSchoolName") {
      const selected = this.state.highSchoolNameData.find(
        (e) => e.Id === parseInt(value)
      );
      updated[index].institutionName =
        value === "8" ? "" : selected?.value || "";
    }

    this.setState({ undergradDegree: updated }, () =>
      this.props.collectState("EH", { underGradDegree: updated })
    );
  }

  addUnderGradDegree = () => {
    const current =
      this.state.undergradDegree[this.state.undergradDegree.length - 1];
    const {
      highSchoolCertificate,
      startDate,
      endDate,
      highSchoolName,
      institutionName,
    } = current;

    const isValid =
      highSchoolCertificate &&
      startDate &&
      endDate &&
      highSchoolName &&
      (highSchoolName !== "8" || institutionName);

    if (!isValid) {
      alert("Please fill all required fields before adding new!");
      return;
    }

    const updated = [...this.state.undergradDegree];
    updated.push({
      highSchoolCertificate: "",
      startDate: "",
      endDate: "",
      highSchoolName: "",
      institutionName: "",
      sectionSpeciality: "",
    });

    this.setState({ undergradDegree: updated }, () =>
      this.props.collectState("EH", { underGradDegree: updated })
    );
  };

  removeEditableEntry() {
    const updated = [...this.state.undergradDegree];
    if (updated.length === 1) return;
    updated.pop();
    this.setState({ undergradDegree: updated }, () =>
      this.props.collectState("EH", { underGradDegree: updated })
    );
  }

  renderUnderGraduate() {
    const {
      loading,
      undergradDegree,
      highSchoolCertificateData,
      highSchoolNameData,
    } = this.state;

    if (loading) return <Loading />;

    return (
      <div>
        <p>
          When entering your high school information make sure you use the
          correct institution’s name and address.
          <br />
          If you have attended different high schools in the previous three
          years, add the previous high school(s) in the field provided with the
          corresponding period of attendance.
          <br />
          When ready, click Next to navigate to the next section
        </p>
        <p>
          {this.props.error?.[0]?.sectionError && (
            <div style={{ color: "red" }}>
              {this.props.error[0].sectionError}
            </div>
          )}
        </p>

        {undergradDegree.map((entry, index) => {
          const validationError = this.props.error?.[index] || {};
          const isEditable = index === undergradDegree.length - 1;

          return (
            <div key={index} className="education-entry">
              {index > 0 && <br />}
              {isEditable && index !== 0 && (
                <div style={{ textAlign: "right" }}>
                  <button
                    onClick={() => this.removeEditableEntry()}
                    style={{
                      background: "none",
                      border: "none",
                      fontSize: "1.2rem",
                      cursor: "pointer",
                    }}
                    title="Cancel"
                  >
                    ✕
                  </button>
                </div>
              )}
              <InputRow
                name="select"
                rowName="School Name"
                required="*"
                data={highSchoolNameData}
                value={entry.highSchoolName}
                disabled={!isEditable}
                errMsg={validationError.highSchoolName || ""}
                onChange={(val) =>
                  this.handleChange(index, "highSchoolName", val)
                }
              />
              {entry.highSchoolName === "8" && (
                <InputRow
                  name="text"
                  rowName="Institution Name"
                  required="*"
                  value={entry.institutionName}
                  disabled={!isEditable}
                  errMsg={validationError.institutionName || ""}
                  onChange={(val) =>
                    this.handleChange(index, "institutionName", val)
                  }
                />
              )}
              <InputRow
                name="select"
                rowName="High School Certificate"
                required="*"
                data={highSchoolCertificateData}
                value={entry.highSchoolCertificate}
                disabled={!isEditable}
                errMsg={validationError.highSchoolCertificate || ""}
                onChange={(val) =>
                  this.handleChange(index, "highSchoolCertificate", val)
                }
              />
              <div style={{ display: "flex", gap: "1rem" }}>
                <InputRow
                  name="date"
                  rowName="From"
                  required="*"
                  value={entry.startDate}
                  disabled={!isEditable}
                  onChange={(val) => this.handleChange(index, "startDate", val)}
                />
                <InputRow
                  name="date"
                  rowName="To"
                  required="*"
                  value={entry.endDate}
                  disabled={!isEditable}
                  onChange={(val) => this.handleChange(index, "endDate", val)}
                />
              </div>
              <div style={{ display: "flex", gap: "1rem" }}>
                <p>
                  Indicate the section/speciality subject(s) when applicable:
                </p>
                <InputRow
                  rowName="Section/Specialty"
                  name="text"
                  value={entry.sectionSpeciality}
                  onChange={(val) =>
                    this.handleChange(index, "sectionSpeciality", val)
                  }
                  disabled={!isEditable}
                />
              </div>
            </div>
          );
        })}
        <button className="save" onClick={this.addUnderGradDegree}>
          + Add New
        </button>
      </div>
    );
  }

  render() {
    const { loading, error } = this.state;
    if (loading) return <Loading />;

    return (
      <div>
        {error && <p style={{ color: "red" }}>{error}</p>}
        {this.renderUnderGraduate()}
        <button className="save" onClick={this.props.onSave}>
          Next
        </button>
      </div>
    );
  }
}

EducationHistoryUndergraduate.propTypes = {
  countryData: PropTypes.array.isRequired,
  program: PropTypes.number.isRequired,
  incompleteApplicationId: PropTypes.number.isRequired,
  onSave: PropTypes.func.isRequired,
  educationHistory: PropTypes.array,
  collectState: PropTypes.func,
  error: PropTypes.object,
  changeFoundation: PropTypes.func,
};
